// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_2J6eS"};